import { LocalePrefix } from "next-intl/routing";

export const locales = ["de", "en", "fr"] as const;
export const defaultLocale = "de" as const;
export const localeDetection = false as const;
export const localePrefix = "always" satisfies LocalePrefix;

export const languages = [
    {
        locale: "de",
        name: "Deutsch",
        icon: '<svg style="width:20px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="#fc0" d="M0 341.3h512V512H0z"/><path fill="#000001" d="M0 0h512v170.7H0z"/><path fill="red" d="M0 170.7h512v170.6H0z"/></svg>',
    },
    {
        locale: "en",
        name: "English",
        icon: '<svg style="width:20px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="#012169" d="M0 0h512v512H0z"/><path fill="#FFF" d="M512 0v64L322 256l190 187v69h-67L254 324 68 512H0v-68l186-187L0 74V0h62l192 188L440 0z"/><path fill="#C8102E" d="m184 324 11 34L42 512H0v-3zm124-12 54 8 150 147v45zM512 0 320 196l-4-44L466 0zM0 1l193 189-59-8L0 49z"/><path fill="#FFF" d="M176 0v512h160V0zM0 176v160h512V176z"/><path fill="#C8102E" d="M0 208v96h512v-96zM208 0v512h96V0z"/></svg>',
    },
    // {
    //     locale: "fr",
    //     name: "Französisch",
    //     icon: '<svg style="width:20px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="#012169" d="M0 0h512v512H0z"/><path fill="#FFF" d="M512 0v64L322 256l190 187v69h-67L254 324 68 512H0v-68l186-187L0 74V0h62l192 188L440 0z"/><path fill="#C8102E" d="m184 324 11 34L42 512H0v-3zm124-12 54 8 150 147v45zM512 0 320 196l-4-44L466 0zM0 1l193 189-59-8L0 49z"/><path fill="#FFF" d="M176 0v512h160V0zM0 176v160h512V176z"/><path fill="#C8102E" d="M0 208v96h512v-96zM208 0v512h96V0z"/></svg>',
    // },
];
